import React, { useState } from 'react';
import { Toaster } from '../../../../../common/Toaster/Toaster';
import WorkoutPeriodRows from '../../../ui/period/WorkoutPeriodRows';

export default function WorkoutEditSection({
  planId,
  weekdayName: _weekdayName,
  userId,
  showHeader = true,
  onChangeTemplate,
  changingTemplate = false,
  onUseOnOtherDays,
  usingOnOtherDays = false,
  onMarkAsRest,
  markingAsRest = false,
  onDurationChange,
  copyTargetDays = null,
}) {
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('default');
  const actionsBusy = changingTemplate || usingOnOtherDays || markingAsRest;

  return (
    <div className="w-full">
      {alertMessage && <Toaster message={alertMessage} type={alertType} />}

      {showHeader && (
        <div className="mb-4">
          <h2 className="text-lg font-bold text-gray-900 capitalize">
            {_weekdayName || 'Edit workout'}
          </h2>
          <p className="text-sm text-gray-500">Add or edit exercises for each period</p>
        </div>
      )}

      {(onChangeTemplate || onUseOnOtherDays || onMarkAsRest) && (
        <div className="mb-4 flex flex-wrap justify-end gap-2">
          {onUseOnOtherDays && (
            <button
              type="button"
              onClick={onUseOnOtherDays}
              disabled={actionsBusy}
              className="text-xs font-medium text-gray-600 hover:text-orange-700 px-3 py-1.5 rounded-lg border border-gray-200 hover:border-orange-200 hover:bg-orange-50/50 disabled:opacity-50"
            >
              Use on other days
            </button>
          )}
          {onChangeTemplate && (
            <button
              type="button"
              onClick={onChangeTemplate}
              disabled={actionsBusy}
              className="text-xs font-medium text-gray-600 hover:text-orange-700 px-3 py-1.5 rounded-lg border border-gray-200 hover:border-orange-200 hover:bg-orange-50/50 disabled:opacity-50"
            >
              Choose another template
            </button>
          )}
          {onMarkAsRest && (
            <button
              type="button"
              onClick={onMarkAsRest}
              disabled={actionsBusy}
              className="text-xs font-medium text-gray-600 hover:text-orange-700 px-3 py-1.5 rounded-lg border border-gray-200 hover:border-orange-200 hover:bg-orange-50/50 disabled:opacity-50"
            >
              Mark as rest
            </button>
          )}
        </div>
      )}

      <WorkoutPeriodRows
        context="plan"
        planId={planId}
        clientId={userId}
        setAlertMessage={setAlertMessage}
        setAlertType={setAlertType}
        onDurationChange={onDurationChange}
        copyTargetDays={copyTargetDays}
      />
    </div>
  );
}
